// import logo from './logonew.png';
// export const CLOUDINARY_UPLOAD_PRESET = 'vldqgwk8';
// export const baseURL = 'https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload';


// export   const Username = '81f3a191-869d-4402-be85-ac9d293ccb71';
// export const Password = 'c9a8a118dc82df9561ac';
// export const baseURLdyte = 'https://api.dyte.io/v2';
// export const baseURLdyteMeeting ='https://app.dyte.io/v2';


// export const logoImage =logo
// // export const logoImage ="https://lider-impulz.vercel.app/static/media/logo1.775c2acf99492d8c08fd.png"

// const now = new Date();
// export const timestamp = now.toISOString().replace(/[-:T.Z]/g, '').slice(0, 14);


// export const buttonBackgroundColor = "#2F58A0";

// import logo from './logonew.png';
// export const CLOUDINARY_UPLOAD_PRESET = 'vldqgwk8';
// export const baseURL = 'https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload';


// export   const Username = '81f3a191-869d-4402-be85-ac9d293ccb71';
// export const Password = 'c9a8a118dc82df9561ac';
// export const baseURLdyte = 'https://api.dyte.io/v2';
// export const baseURLdyteMeeting ='https://app.dyte.io/v2';


// export const logoImage =logo
// // export const logoImage ="https://lider-impulz.vercel.app/static/media/logo1.775c2acf99492d8c08fd.png"

// const now = new Date();
// export const timestamp = now.toISOString().replace(/[-:T.Z]/g, '').slice(0, 14);


// export const buttonBackgroundColor = "#2F58A0";



import logo from './logonew.png';
export const CLOUDINARY_UPLOAD_PRESET = 'vldqgwk8';
export const baseURL = 'https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload';


// Existing configurations

// export   const Username = '81f3a191-869d-4402-be85-ac9d293ccb71';
// export const Password = 'c9a8a118dc82df9561ac';
// export const baseURLdyte = 'https://api.dyte.io/v2';
// export const baseURLdyteMeeting ='https://app.dyte.io/v2';

export   const Username = 'c695814c-7c71-4615-a9f5-617c45cb55f8';
export const Password = '3e791128537845f8c8f2';
export const baseURLdyte = 'https://api.dyte.io/v2';
export const baseURLdyteMeeting ='https://app.dyte.io/v2';
export const dyteRestHeader = 'Basic YzY5NTgxNGMtN2M3MS00NjE1LWE5ZjUtNjE3YzQ1Y2I1NWY4OjNlNzkxMTI4NTM3ODQ1ZjhjOGYy';


export const logoImage =logo
// export const logoImage ="https://lider-impulz.vercel.app/static/media/logo1.775c2acf99492d8c08fd.png"

const now = new Date();
export const timestamp = now.toISOString().replace(/[-:T.Z]/g, '').slice(0, 14);


export const buttonBackgroundColor = "#2F58A0";